<template>
  <EditorPopover ref="popover" @cancel="cancelEditing">

    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-measure">
          <i class="far fa-ruler"></i> Measure Tool
        </Tab>
      </template>

      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-measure">
          Measure Line Length: {{formatDecimal(lineLength, 2)}}mm
          <div class="row form-group" v-if="editingEnabled">
            <label class="col-form-label col-4">Add Dimension To Datum</label>
            <div class="col-8">
              <FormSwitch booleanMode v-model="showDimension" />
            </div>
          </div>

          <EditorPopoverButtonList v-if="editingEnabled">
            <EditorPopoverButton title="Cancel" type="cancel" icon="fa-times" @click="cancelEditing" />
            <EditorPopoverButton title="Add Datum Line" type="action" icon="fa-plus-square" @click="popoverActionButtonClick('addDatum', { showDimension: showDimension })" :disabled="!addDatumAvailable" />
          </EditorPopoverButtonList>
        </TabPage>
      </template>
    </TabbedBox>  
    
  </EditorPopover>
</template>



<script>
import _ from 'lodash'
import Utils from '@/utils/utils'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorPopoverMixin from '@glass-designer/mixins/editorPopover'
import EditorPopoverDataRow from '@glass-designer/components/editorPopoverDataRow'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import MathsUtils from '@/utils/mathsUtils'

import EditorPopoverButtonList from '@glass-designer/components/popover/editorPopoverButtonList'
import EditorPopoverButton from '@glass-designer/components/popover/editorPopoverButton'

import { LibraryItemShapeTypes } from '@glass-designer/types'

export default {
  name: 'EditorMeasureToolPopover',
  mixins: [EditorPopoverMixin],
  components: {
    EditorPopover,
    EditorPopoverDataRow,
    EditorPopoverButtonList,
    EditorPopoverButton
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      toolInfoText: '',
      name: '',
      lineLength: 0,
      addDatumAvailable: false,
      showDimension: false
    }
  },
  computed: {
  },
  watch: {
    showDimension: function() {
      this.debouncedUpdateTool()
    }    
  },
  created() {
    this.debouncedUpdateTool = _.debounce(this._updateTool, 100)

  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      this.name = options.name || 'Datum Line'
      let measureData = options.measureData || {}
      this.lineLength = measureData.lineLength || 0
      this.showDimension = !!measureData.showDimension
      this.addDatumAvailable = measureData.addDatumAvailable

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.actionCallback = options.actionCallback
      this.applyCallback = options.applyCallback
      this.cancelCallback = options.cancelCallback
    },
    clearOptions() {
      this.itemData = null

      this.callbackContext = null
      this.updateCallback = null
      this.actionCallback = null
      this.applyCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    onShortcutKey(code) {
      switch(code) {
        case 'Escape':
          this.cancelEditing()
          break
      }
    },
    _updateTool() {
      this.updateTool({ apply: false })
    },
    updateTool(options = {}) {
      try {
        if(options.apply) {
          if(this.applyCallback) {
            this.applyCallback(this.callbackContext, {
              showDimension: this.showDimension,
              actionTag: options.actionTag
            })
            this.hide()
          }
        } else {
          if(this.updateCallback) {
            this.updateCallback(this.callbackContext, {
              showDimension: this.showDimension
            })
          }
        }

      } catch(err) {
        console.error(err)
      }

    }
  }
}
</script>